import { render, staticRenderFns } from "./IconLove.vue?vue&type=template&id=65c9296a&scoped=true&"
import script from "./IconLove.vue?vue&type=script&lang=js&"
export * from "./IconLove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9296a",
  null
  
)

export default component.exports